import { Component, input } from '@angular/core';
import {
  CoreJssProxyModule,
  ImageField,
  LinkField,
  TextField,
} from '@core/jss-proxy';

import { ProductCardComponent } from '../product-card/product-card.component';

export interface ProductCard {
  title: TextField;
  content: TextField;
  button1: LinkField;
  button2?: LinkField;
  image: ImageField;
  usps: TextField[];
  cost?: TextField;
  costAddition?: TextField;
}

@Component({
  selector: 'wl-product-card-section',
  standalone: true,
  imports: [CoreJssProxyModule, ProductCardComponent],
  templateUrl: './product-card-section.component.html',
  styleUrls: [
    './product-card-section.component.ed.scss',
    './product-card-section.component.essent.scss',
  ],
})
export class ProductCardSectionComponent {
  readonly title = input.required<TextField>();
  readonly content = input<TextField>();
  readonly cards = input.required<ProductCard[]>();
}
